import { render } from "./ShinyIcon.vue?vue&type=template&id=41d3c37a"
const script = {}

import exportComponent from "/Users/eliott/Developer/Perso/pogodex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__